import React from "react";
import { Link } from "react-router-dom";
import { Rocket } from "lucide-react";
import PartnerPageHeader from "../components/PartnerPageHeader";
import TierComparisonTable from "../components/TierComparisonTable";
import {
  MARGIN_SCAN,
  MARGIN_THESIS,
} from "@/pages/LandingPages/marketingAgency/marginProtection/marginProtectionContent";
import { PARTNER_POOL_CALLOUT, PARTNER_POOL_BULLETS } from "@/constants/partnerPoolContent";

const PartnerTiers = () => (
  <div data-testid="partner-tiers">
    <PartnerPageHeader
      tag="The profit matrix"
      title="Tier & margin"
      titleAccent="catalog"
      subtitle="Match clients to infrastructure tiers. Wholesale costs stay classified. Your clients only see your brand."
    />

    <div className="grid sm:grid-cols-3 gap-4 mb-8">
      {MARGIN_SCAN.map((item) => (
        <div key={item.label} className="rounded-xl border border-partner bg-[#11151F] p-4 text-center">
          <p className="text-2xl font-bold text-partner-accent">{item.value}</p>
          <p className="text-xs font-mono tracking-wider text-partner-muted uppercase mt-1">
            {item.label}
          </p>
          <p className="text-xs text-partner-muted font-body mt-0.5">{item.sub}</p>
        </div>
      ))}
    </div>

    <div className="rounded-xl border border-[#00D2FF]/20 bg-[#00D2FF]/5 px-5 py-4 mb-8">
      <p className="text-sm font-semibold text-partner mb-1">{MARGIN_THESIS.headline}</p>
      <p className="text-sm text-partner-muted font-body">{MARGIN_THESIS.insight}</p>
    </div>

    <TierComparisonTable className="mb-8" />

    <div className="rounded-xl border border-partner bg-[#11151F] p-5 sm:p-6 mb-8">
      <p className="text-sm font-semibold text-partner mb-2">{PARTNER_POOL_CALLOUT.headline}</p>
      <p className="text-sm text-partner-muted font-body mb-4">{PARTNER_POOL_CALLOUT.insight}</p>
      <ul className="space-y-2">
        {PARTNER_POOL_BULLETS.map((bullet) => (
          <li key={bullet.title} className="text-sm text-partner font-body flex gap-2">
            <span className="text-partner-accent shrink-0">•</span>
            <span>
              <strong className="text-partner">{bullet.title}:</strong>{" "}
              <span className="text-partner-muted">{bullet.body}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>

    <Link
      to="/partner/deploy"
      className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-[#00D2FF] text-[#080A0F] font-semibold text-sm hover:bg-[#00D2FF]/90 transition-colors"
    >
      <Rocket className="w-4 h-4" />
      Deploy a client
    </Link>
  </div>
);

export default PartnerTiers;
